var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-logo-container",class:{ collapse: _vm.collapse }},[_c('router-link',{staticClass:"sidebar-logo-link",attrs:{"to":"/"}},[_c('span',{staticClass:"logo-text"},[_vm._v(_vm._s(_vm.collapse ? '51' : '51gp'))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e017a72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/admin/layout/components/Sidebar/Logo.vue
// module id = null
// module chunks = 